/**
 * @param {string[]} names
 * @returns {null|HTMLElement}
 */
const findInputElement = (names) => {
  let element = null;

  for (const name of names) {
    element = document.querySelector(`input[name="${name}"]`);
    if (element) {
      break;
    }
  }

  return element;
};

const getVatDisplayFromSearchParam = () => {
  return new URLSearchParams(window.location.search).get('vat-display');
};

export default function vatToggle(store) {
  const getVatDisplay = () => {
    return window.localStorage.getItem('adwise-vat-display') === 'including';
  };

  const update = (value) => {
    store.commit('setIncludingVat', value);
  };

  const vatDisplaySearchParam = getVatDisplayFromSearchParam();
  if (vatDisplaySearchParam !== null) {
    update(vatDisplaySearchParam === 'including');
  } else {
    update(getVatDisplay());
  }

  // The extra `"` seems like a mistake in Magento. So in case they remove it then it will still work.
  const names = ['adwise-vat-display\\"', 'adwise-vat-display'];
  const inputElement = findInputElement(names);

  if (!inputElement) {
    console.error(
        `VAT toggle element not found with names: '${names.join(', ')}'`
    );
    return;
  }
  const clickElement = inputElement.parentElement?.nextSibling;
  if (!clickElement) {
    console.error('VAT click element not found');
    return;
  }

  clickElement.addEventListener('click', () => {
    // Timeout is needed because the value is not in localStorage yet
    setTimeout(() => {
      update(getVatDisplay());
    }, 50);
  });
}
